import React from 'react';

import { mapAvailabilityStatementToSchema } from '../../../../utils/schema';
import { AvailabilityStatementType } from '@jbhi-fi/apis/src/shopify/types/OnlineProduct';
import { removeHTMLTags } from '../utils/utils';
import { getStoreCurrency } from '@jbhi-fi/utils/src/shopify/getStoreCurrency';

export type PdpSchemaProps = {
  sku?: number;
  price?: number;
  pdpCategory?: string;
  schemaTitle?: string;
  gtin?: string;
  brand?: string;
  numberOfReviews?: number;
  averageReviews?: number;
  handle?: string | null;
  productFeaturedImage?: string | null;
  productDescription?: string | null;
  highlight?: string | null;
  availabilityStatement?: AvailabilityStatementType;
  productCondition?: string;
};

const PdpSchema = ({
  sku,
  price,
  pdpCategory,
  schemaTitle,
  gtin,
  brand,
  numberOfReviews,
  averageReviews,
  handle,
  productFeaturedImage,
  productDescription,
  highlight,
  availabilityStatement,
  productCondition,
}: PdpSchemaProps) => {
  let description = productDescription ? productDescription : highlight;
  if (description) {
    description = removeHTMLTags(description);
  }

  const schema = {
    '@context': 'https://schema.org',
    '@type': 'Product',
    '@id': document.querySelector("link[rel='canonical']")?.getAttribute('href'),
    mainEntityOfPage: `${window.location.origin}/products/${handle}`,
    url: `${window.location.origin}/products/${handle}`,
    image: `https:${productFeaturedImage}`,
    name: schemaTitle,
    sku: sku,
    description: description,
    category: pdpCategory,
    gtin: gtin,
    brand: {
      '@type': 'Brand',
      name: brand,
    },
    aggregateRating:
      typeof numberOfReviews === 'number' && numberOfReviews > 0
        ? {
            '@type': numberOfReviews > 0 ? 'AggregateRating' : undefined,
            ratingValue: numberOfReviews > 0 ? averageReviews : undefined,
            reviewCount: numberOfReviews > 0 ? numberOfReviews : undefined,
          }
        : undefined,
    offers: {
      '@type': 'Offer',
      url: document.querySelector("link[rel='canonical']")?.getAttribute('href'),
      availability: `https://schema.org/${mapAvailabilityStatementToSchema(availabilityStatement)}`,
      itemCondition:
        productCondition?.toLowerCase() === 'refurbished'
          ? 'http://schema.org/RefurbishedCondition'
          : 'http://schema.org/NewCondition',
      price: price,
      priceCurrency: getStoreCurrency(),
    },
  };

  return <script type="application/ld+json">{JSON.stringify(schema)}</script>;
};

export default PdpSchema;
